export default {
  A4_Vertical: 'CDT_B03_01',
  A4_Horizontal: 'CDT_B03_02',
};
